/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackupReportResponse {
    getFixupPrototypeFunction() { return BackupReportResponse.fixupPrototype; }

    static newInstance(model: Partial<BackupReportResponse>): BackupReportResponse {
        let obj = Object.assign(new BackupReportResponse(), model);
        BackupReportResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackupReportResponse>): BackupReportResponse {
        if (!model) return null;
        return BackupReportResponse.newInstance(<BackupReportResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackupReportResponse) {
        if (!obj) return;

        models.BackupReportResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackupReportResponse): boolean {
        Object.setPrototypeOf(obj, BackupReportResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * status response
     */
    status: string;

    /**
     * message response
     */
    message: string;

    /**
     * Backup data
     */
    data: any;

}
